import SettingService from '../../services/SettingService';
import AccountService from '../../services/AccountService';
import AppPrefixUtils from '../../utils/AppPrefixUtils';
import CompanyService from '../../services/CompanyService';
import AbstractConfirmPasswordContainer from './AbstractConfirmPasswordContainer';
import {withTranslation} from 'react-i18next';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';

class ConfirmPasswordContainer extends AbstractConfirmPasswordContainer {
    constructor(props) {
        super(props);
        this.service = new AccountService();
        this.companyService = new CompanyService();
    }

    // @Override
    getPasswordParams = () => {
        const settingService = new SettingService();
        return settingService
            .getPasswordParamsPublic()
            .then((resp) => {
                this.setState(
                    {
                        maxLength: resp['PASSWORD_MAX_LENGTH'],
                        minLength: resp['PASSWORD_MIN_LENGTH'],
                        lowerCaseCount: resp['PASSWORD_LOWERCASE_COUNT'],
                        upperCaseCount: resp['PASSWORD_UPPERCASE_COUNT'],
                        numbersCount: resp['PASSWORD_NUMBERS_COUNT'],
                        specialCharactersCount: resp['PASSWORD_SPECIAL_CHARS_COUNT'],
                    },
                    () => this.unblockUi()
                );
            })
            .catch((err) => this.unblockUi());
    };

    getService = () => {
        return this.service;
    };

    handleCorrectPasswordToken = (wsRes) => {
        if (wsRes.login) {
            this.setState({email: wsRes.login});
            this.unblockUi();
        } else {
            this.handleErrorPasswordToken();
        }
    };

    handleErrorPasswordToken = () => {
        const {t} = this.props;
        this.saveCookie(
            this.getResetPasswordContainerName(),
            JSON.stringify({
                severity: 'error',
                summary: '',
                detail: t('account.incorrectToken'),
            })
        );
    };

    handleCorrectPasswordChange = () => {
        this.blockUi();
        this.persistMessage(
            'success',
            '',
            this.props.type === 'CREATE' ? 'Hasło zostało nadane pomyślnie' : 'Hasło zostało zmienione pomyślnie'
        );
        if (this.props.type === 'CREATE') {
            if (this.props.onAfterLogin) {
                this.authService
                    .login(this.state.email, this.state.newPassword)
                    .then((res) => {
                        const id_token = sessionStorage.getItem('id_token');
                        const locale = this.authService.getLanguageFromToken(res.token);
                        sessionStorage.setItem('i18nextLng', locale);
                        sessionStorage.setItem('id_token', id_token);
                        // After setting password for new user, decide redirect (wizard if company incomplete)
                        this.companyService
                            .get()
                            .then((company) => {
                                const missingLogo = !company?.logoUuid;
                                const missingLocations = !Array.isArray(company?.locations) || company.locations.length === 0;
                                const path = (missingLogo || missingLocations) ? '/company/setup' : '/dashboard';
                                window.location.href = AppPrefixUtils.locationHrefUrl(path);
                            })
                            .catch(() => {
                                window.location.href = AppPrefixUtils.locationHrefUrl('/dashboard');
                            });
                    })
                    .catch((err) => {
                        console.log('err', err);
                        if (err.status === 401 || err.status === 403) {
                            this.showErrorMessage('Błąd logowania', 10000, true, 'Błąd ');
                        } else {
                            this.showErrorMessage(err.message);
                        }
                        this.unblockUi();
                    });
            }
        } else {
            window.location.href = AppPrefixUtils.locationHrefUrl('/login');
        }
    };

    renderDetail = () => {
        return this.renderForm();
    };

    getResetPasswordContainerName() {
        return 'reset-password';
    }

    getContainerListName() {
        return 'login-page';
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    persistMessage(severity, summary, detail) {
        this.saveCookie(
            this.getContainerListName(),
            JSON.stringify({
                severity,
                summary,
                detail,
            })
        );
    }
}
export default withRouter(withTranslation()(ConfirmPasswordContainer));
